import { ArrowLeft } from 'lucide-react'

import { Link, useParams } from '@/lib/router'

import { CaseDetailBody } from './CaseDetailBody'

/**
 * Full-route case detail at /cases/{caseId} — used for deep links and
 * shared URLs. The day-to-day "open this case" flow on /cases uses the
 * side drawer instead, which preserves queue context.
 */
export function CaseDetailPage() {
  const { caseId } = useParams<{ caseId: string }>({ from: '/cases/$caseId' })
  return (
    <div className="mx-auto max-w-[1400px] space-y-5">
      <Link to="/cases" className="inline-flex items-center gap-1 text-2xs font-semibold uppercase tracking-wider text-navy-700 hover:underline">
        <ArrowLeft className="h-3 w-3" /> Back to cases
      </Link>
      <CaseDetailBody caseId={caseId} />
    </div>
  )
}
